import { Box, Card, Typography } from '@mui/material'
import React from 'react'
import { DetailInfoProps } from './MapSection'
import { t } from 'i18next'

function MapDetailCard({ detail }: { detail: DetailInfoProps }) {
    return (
        <Box display={'flex'} gap={2} alignItems={'center'}>
            <Card elevation={1} sx={{ width: 75, height: 75, position: 'relative', display: { md: 'flex', xs: 'none' }, justifyContent: 'center', alignItems: 'center', borderRadius: '50%' }} >
                <div className="icon">
                    <span className={detail.icon}>
                        <span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span></span>
                </div>
            </Card>
            <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} alignItems={'flex-start'}>
                <Typography fontWeight={500} fontSize={{ md: 18, xs: 14 }}>{detail?.value ?? '-'}</Typography>
                <Typography variant='caption' fontWeight={400} color={'#808080'}>{t(detail.title)}</Typography>
            </Box>
        </Box>
    )
}

export default MapDetailCard